import React from "react";

const Offering = () => {
  return (
    <section
      className="relative p-10 md:p-16 text-center text-white"
      style={{
        backgroundImage: "url('/offering.jpg')",
        backgroundSize: "cover",
        backgroundPosition: "center",
      }}
    >
      {/* Dark overlay for readability */}
      <div className="absolute inset-0 bg-black/70"></div>

      {/* Content */}
      <div className="relative z-10 max-w-2xl mx-auto">
        <h2 className="text-3xl md:text-4xl font-bold mb-4">
          Offering Time
        </h2>

        <p className="mb-4 text-lg italic">
          “God loves a cheerful giver”
        </p>

        <p className="mb-6 text-yellow-300 font-semibold">
          — 2 Corinthians 9:7
        </p>

        {/* Giving Instructions */}
        <div className="bg-white/10 p-4 rounded-lg mb-6">
          <p className="mb-2">You can support this ministry:</p>
          <p>💳 CashApp: <strong>$YourChurchName</strong></p>
          <p>🏦 Bank: Your Bank Name</p>
          <p>📱 Zelle: your@email.com</p>
        </div>

        {/* CTA Button */}
        <button className="bg-yellow-500 hover:bg-yellow-400 text-black font-bold px-6 py-3 rounded-lg transition">
          Give Now
        </button>

        {/* Background Music */}
        <audio controls className="mt-6 w-full">
          <source src="/offering-music.mp3" type="audio/mpeg" />
        </audio>
      </div>
    </section>
  );
};

export default Offering;